import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppSettingsService } from '../config/config-service';
import { CommonService } from './common.service';

export interface Portfolio {
  _id: string;
  name: string;
  riskLevel: string;
  description: string;
  roiPotential: number;
  tenure: number;
  ticketPrice: number;
  totalTickets: number;
  availableTickets: number;
  soldTickets: number;
  images: string[];
  investmentFocus: string[];
  investmentStartDate: string;
  investmentClosureDate: string;
  status: string;
  isActive: boolean;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  __v: number;
  adminNote?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  apiUrl: string | undefined;

  constructor( private http: CommonService,  private appSettingsService: AppSettingsService) {
    this.apiUrl = this.appSettingsService.getSettings().apiEndPoint || '';
  }

  getAllPortfolios(): Observable<Portfolio[]> {
    return this.http.get<{ success: boolean; count: number; data: Portfolio[] }>(`${this.apiUrl}/api/portfolios/getAllPortfoliosforClient`).pipe(
      map(response => response.data),
      catchError(this.handleError)
    );
  }

  createTransaction(payload: {
    userId: string;
    portfolioId: string;
    amount: number;
    ticketsPurchased: number;
  }): Observable<{ success: boolean; data?: any; message?: string }> {
    return this.http.post<{ success: boolean; data?: any; message?: string }>(
        `${this.apiUrl}/api/transactions/createTransaction`,
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      )
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error instanceof HttpErrorResponse) {
      if (error.error?.message) {
        errorMessage = error.error.message;
      } else if (error.status === 404) {
        errorMessage = 'Portfolios not found.';
      } else if (error.status === 500) {
        errorMessage = 'Server error. Please try again later.';
      }
    }
    return throwError(() => new Error(errorMessage));
  }
}
